import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { PlusCircle, PlusSquare } from '../Icons/index.js';
import { File, FileDropzone, Panel, Table } from '../index.js';
import DocumentsTableRow from './DocumentsTableRow.js';
const DocumentsPicker = (props) => {
    const dropzoneRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const { documents } = props;
    const [attachedFiles, setAttachedFiles] = useState([]);
    const updateFiles = (files) => {
        setAttachedFiles(files);
        props.onChange(files);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FileDropzone, { onChange: (file) => updateFiles([...attachedFiles, file]), dropzoneRef: dropzoneRef },
            React.createElement(Panel, { header: lang.documents.documents },
                React.createElement(Table, { zebra: true }, documents
                    .filter((d) => d.file)
                    .sort((a, b) => a.id - b.id)
                    .map((document) => {
                    return (React.createElement(DocumentsTableRow, { document: document, key: document.documentId, hideInfo: true, selectable: true, selectableOnChange: (checked) => {
                            if (checked) {
                                updateFiles([
                                    ...attachedFiles,
                                    document.signedFile || document.file,
                                ]);
                            }
                            else {
                                updateFiles(attachedFiles.filter((f) => f.fileId !==
                                    (document.signedFile || document.file).fileId));
                            }
                        }, selectableChecked: attachedFiles.some((f) => f.fileId ===
                            (document.signedFile || document.file).fileId) }));
                }))),
            React.createElement("div", { style: { marginTop: '20px' } },
                !!(attachedFiles || [])?.length &&
                    (attachedFiles || []).map((file, i) => (React.createElement(File, { key: file.fileId, file: file, onRemove: () => updateFiles(attachedFiles.filter((f) => f.fileId !== file.fileId)), removable: true }))),
                React.createElement(AddFileButton, { title: lang.interactions.addFiles, onClick: () => {
                        if (dropzoneRef.current != null) {
                            // @ts-ignore
                            dropzoneRef.current?.open();
                        }
                    } })))));
};
export default DocumentsPicker;
const AddFileButton = (props) => {
    return (React.createElement(FileStyled, { onClick: props.onClick },
        React.createElement("div", { style: { maxWidth: '100%' } },
            React.createElement("div", null,
                React.createElement("div", { className: "file-icon" },
                    React.createElement(PlusCircle, null),
                    React.createElement(PlusSquare, { className: "file-drag-icon" })),
                props.title))));
};
const FileStyled = styled.div `
  display: inline-flex;
  max-width: 100%;
  justify-content: space-between;
  padding: 5px 15px;
  position: relative;
  font-size: 12px;
  border-radius: 15px;
  margin-right: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  color: ${THEME.COLOR_ACCENT};
  border: 1px solid lightgrey;
  font-weight: 900;

  a {
    color: initial;
    text-decoration: none;
  }

  .file-icon {
    display: inline-block;
    margin: -2px 0 -2px 0;

    svg {
      margin: 0.2em 0em 0.2em 0em;
      transition: transform 0.2s;
      display: block;
    }

    height: 1.2em;
    width: 1.2em;
    overflow: hidden;
  }

  transition: transform 0.2s;

  &:hover {
    .file-icon {
      svg {
        transform: translate3d(0em, -1.2em, 0);
      }
    }
  }
`;
//# sourceMappingURL=DocumentsPicker.js.map